/**
 * Parse input date string from 'dd/mm/yyyy' format and convert to Date object
 * @param dateString
 */
export function parseDateString(dateString: string) {
  if (!dateString) {
    return null
  }
  const [day, month, year] = dateString.split('/').map(Number)
  const dateObj = new Date(year, month - 1, day) // month is 0-indexed in JavaScript

  dateObj.setMinutes(dateObj.getMinutes() + dateObj.getTimezoneOffset())

  return dateObj
}
